import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  error: {
    id: 'studio.deMebf',
    defaultMessage: 'There was a problem extending your subscription.',
  },
  title: {
    id: 'studio.dJlnNE',
    defaultMessage: 'Extend subscription',
  },
  help: {
    id: 'studio.uV2tEV',
    defaultMessage: 'What billing period do you prefer?',
  },
  billingPeriod: {
    id: 'studio.u2XWYU',
    defaultMessage: 'Billing period',
  },
  extendSubscription: {
    id: 'studio.dJlnNE',
    defaultMessage: 'Extend subscription',
  },
  billingPeriodHelp: {
    id: 'studio.5HnMb8',
    defaultMessage: 'What billing period you prefer.',
  },
  month: {
    id: 'studio.TBovrx',
    defaultMessage: 'Month',
  },
  year: {
    id: 'studio.IFo1oo',
    defaultMessage: 'Year',
  },
});
